import { SurveyLocationStatisticsFragment } from '@occc/graphql';

import { TableBody } from '@occc/ui-design-system';
import { SurveyStatisticsBarChartItem, SurveyStatisticsPieChartItem } from './types';
import { SurveyLocationTableBodyExpandableRow } from './SurveyLocationTableBodyExpandableRow';

type SurveyLocationsTableBodyProps = {
  data?: Array<SurveyLocationStatisticsFragment>;
  responseStatisticsPerLocationMap: Record<
    string,
    SurveyStatisticsPieChartItem | SurveyStatisticsBarChartItem
  >;
};

export const SurveyLocationsTableBody = ({
  data,
  responseStatisticsPerLocationMap,
}: SurveyLocationsTableBodyProps) => (
  <TableBody>
    {data?.map((location) => (
      <SurveyLocationTableBodyExpandableRow
        key={location.siteId}
        responseStatisticsPerLocation={responseStatisticsPerLocationMap[location.siteId]}
        location={location}
      />
    ))}
  </TableBody>
);
